module.exports = __webpack_public_path__ + "static/media/blog-episode-detail.2ad53cb0.png";